<template>
    <div>
        <vs-row>
            <vs-col vs-lg="7" vs-sm="12" class="p-2">
                <h4 class="mb-4">My Cards</h4>
                <div style="padding: 16px;" class="border_card mb-4">
                    <div class="flex flex-wrap justify-end">
                        <vs-button class="m-1">Edit</vs-button>
                        <vs-button type="border" color="danger" class="m-1">Delete</vs-button>
                    </div>
                    <div class="flex flex-wrap justify-between items-end mb-4">   
                        <div class="inline-flex items-start">
                            <div>
                                <h5>John Smith</h5>
                                <p style="color: #C6C6C6;">**** **** 9865</p>
                            </div>
                            <p class="cstm_badge primary ml-5">Primary</p>                 
                        </div> 
                        <p>Card expires at 12/24</p>
                    </div>
                </div>

                <div style="padding: 16px;" class="border_card mb-4">
                    <div class="flex flex-wrap justify-end">
                        <vs-button class="m-1">Edit</vs-button>
                        <vs-button type="border" color="danger" class="m-1">Delete</vs-button>
                    </div>
                    <div class="flex flex-wrap justify-between items-end mb-4">   
                        <div class="inline-flex items-start">
                            <div>
                                <h5>John Smith</h5>
                                <p style="color: #C6C6C6;">**** **** 9865</p>
                            </div>
                        </div> 
                        <p>Card expires at 12/24</p>
                    </div>
                </div>
            </vs-col>
            <vs-col vs-lg="5" vs-sm="12" class="p-2">
                <div style="background: #EBFBFC;" class="light_blue_holder p-8">
                    <vs-radio vs-value="credit" v-model="card" class="mr-4">Credit/Debit/ATM Card</vs-radio>
                    <vs-radio vs-value="paypal" v-model="card">PayPal account</vs-radio>

                    <vs-row>
                        <vs-col vs-w="12" class="p-2">
                            <vs-input label="Card Number" placeholder="Enter Card Number" class="w-full" />
                        </vs-col>
                        <vs-col vs-lg="6" vs-sm="12" class="p-2">
                            <vs-input label="Name On Card" placeholder="Enter Name On Card" class="w-full" />
                        </vs-col>
                        <vs-col vs-lg="3" vs-sm="12" class="p-2">
                            <vs-input label="Expiration Date" placeholder="Enter Date" class="w-full" />
                        </vs-col>
                        <vs-col vs-lg="3" vs-sm="12" class="p-2">
                            <vs-input label="CVV" placeholder="Enter CVV" class="w-full" />
                        </vs-col>
                    </vs-row>
                    <div class="inline-flex items-center my-5">
                        <vs-switch v-model="comment" />
                        <span class="ml-4">Save Card for futcher billing?</span>
                    </div>
                    <div class="flex flex-wrap">
                        <vs-button class="m-1">Save Changes</vs-button>
                        <vs-button type="border" color="danger" class="m-1">Discard</vs-button>
                    </div>
                </div>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import vSelect from 'vue-select' 
 
export default {
  data () {
    return {
      frequency: 'weekly',
      settings: false,
      settings_table: [
        {
          id: 1,
          day: 'Monday',
          hourly_rate: '20.00',
          guaranteed_hour: '2'
        }
      ],
      card: 'credit'
    }
  },
  components: {
    vSelect
  }
}
</script>